export enum Platform {
  APP_PROZIS_STORE = 'APP_PROZIS_STORE',
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE'
}
